import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { UserReportReasonType } from "../models/base/UserReportReasonType";
import { UserReportStatusType } from "../models/base/UserReportStatusType";
import { CreateUserReportDTO, UpdateReportDTO } from "../models/userReport/userReport.request";
import { UserReportInfoSettingsDTO, UserReportTableInfoDTO } from "../models/userReport/userReport.response";


export const UserReportsService = {

    async getUserReports(startDate?: string, endDate?: string, status?: UserReportStatusType, reasonType?: UserReportReasonType): Promise<ApiResponse<UserReportTableInfoDTO[]>> {
        const { data } = await api.get<ApiResponse<UserReportTableInfoDTO[]>>(`/userReports/settings`, {
            params: {
                endDate,
                startDate,
                reasonType,
                status,
            }
        });
        return data;
    },

    async createUserReport(dto: CreateUserReportDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>(`/userReports`, dto);
        return data;
    },

    async getUserReportSettings(reportId: string): Promise<ApiResponse<UserReportInfoSettingsDTO>> {
        const { data } = await api.get<ApiResponse<UserReportInfoSettingsDTO>>(`/userReports/${reportId}/settings`);
        return data;
    },

    async updateUserReportSettings(reportId: string, dto: UpdateReportDTO): Promise<ApiResponse<string>> {
        const { data } = await api.put<ApiResponse<string>>(`/userReports/${reportId}`, dto);
        return data;
    }

};
